// リリースノートの各変更の対象と、対象を指定して開く URL（#2055）。
// 原本の読み込み（releaseNotes.ts、ビルド時に fs を使う）と、ブラウザで動く一覧・各画面のリンクの両方から使うため、
// fs にも "use client" にも依存しないこのファイルに分けて置く。

export const RELEASE_NOTE_AUDIENCES = ["general", "employer", "university"] as const;

export type ReleaseNoteAudience = (typeof RELEASE_NOTE_AUDIENCES)[number];

export const RELEASE_NOTE_AUDIENCE_LABELS: Record<ReleaseNoteAudience, string> = {
  general: "一般向け",
  employer: "企業向け",
  university: "大学向け",
};

// 最初に選んでおく対象を URL の ?for= で受け取る。企業・大学の管理画面のリンクが付ける。
export const RELEASE_NOTE_AUDIENCE_PARAM = "for";

// ?for= がないとき（LP・求職者のアプリ・直接開いたとき）に最初に選んでおく対象。
export const DEFAULT_RELEASE_NOTE_AUDIENCE: ReleaseNoteAudience = "general";

// リリースノートを開く URL。管理画面のリンクは対象を付け、その利用者向けを最初に選んだ状態で開く。
// 対象を省くと一般向けを選んだ状態で開く。
export function releaseNotesHref(audience?: ReleaseNoteAudience): string {
  return audience ? `/release-notes?${RELEASE_NOTE_AUDIENCE_PARAM}=${audience}` : "/release-notes";
}

export function isReleaseNoteAudience(value: unknown): value is ReleaseNoteAudience {
  return typeof value === "string" && (RELEASE_NOTE_AUDIENCES as readonly string[]).includes(value);
}

export interface ReleaseNoteItem {
  audiences: ReleaseNoteAudience[];
  text: string;
}

export interface ReleaseNote {
  version: string;
  publishedOn: string;
  items: ReleaseNoteItem[];
}
